<div style="display:flex">
  <kendo-grid id="kendoGridLocalization"
              [kendoGridBinding]="gridData"
              [sortable]="true"
              [selectable]="selectableSettings"
              (selectionChange)="onRowSelected($event)"
              (cellClick)="cellClick($event)"
              (dblclick)="onDoubleClicked()"
              [filterable]="'menu'"
              [pageSize]="10"
              [pageable]="true"
              [scrollable]="'scrollable'"
              style="width:100%; border: none;"
              kendoGridSelectBy="id"
              [(selectedKeys)]="selectedLocalization">
    <kendo-grid-column field="description" title="Language Name" [width]="220">
    </kendo-grid-column>
    <kendo-grid-column field="isDefault" title="Default" [width]="100">
      <ng-template kendoGridCellTemplate let-dataItem>
        <input type="checkbox" [checked]="dataItem.isDefault" style="pointer-events: none;">
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="locale" title="Locale" [width]="150">
    </kendo-grid-column>
    <kendo-grid-column field="isActiveDescription" title="Active" [width]="100">
    </kendo-grid-column>
    <kendo-grid-column field="createdByDescription" title="Created By" [width]="150">
    </kendo-grid-column>
    <kendo-grid-column field="createdOn" title="Created On" [width]="150">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.createdOn | date:'yyyy-MM-dd' }}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="numberFormat" title="Number Format" [width]="200">
    </kendo-grid-column>
    <kendo-grid-column field="dateFormat" title="Date Format" [width]="150">
    </kendo-grid-column>
  </kendo-grid>
</div>
